/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1057
 */

module.exports = {
  formItemWrapper: "WidgetStyleForm_formItemWrapper__1bleY",
  formGroup: "WidgetStyleForm_formGroup__2buWF",
  formGroupHasHelpUrl: "WidgetStyleForm_formGroupHasHelpUrl__mrU4u",
  main: "WidgetStyleForm_main__iMmO_"
}
